import axios from "../axiosInstance";

const DealAPI = {
  addDetails: (payload) => axios.post("deal-of-the-day/", payload),

  getList: (params) => axios.get(`deal-of-the-day/`, { params }),

  getSingleDetails: (id) => axios.get(`deal-of-the-day/${id}`),

  updateDetails: (id, payload) => axios.put(`deal-of-the-day/${id}`, payload),

  updateStatus: (id) => axios.patch(`deal-of-the-day/${id}/status`),

  deleteItem: (id) => axios.delete(`deal-of-the-day/${id}`),
};

export default DealAPI;
